angular.module('internal.login',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.login', {
            url: '/login',
            views: {
                'content': {
                    templateUrl: 'js/internal/login/login.view.html',
                    controller:'LoginCtrl'
                }
            }
        });
    }]);